module.exports = __webpack_public_path__ + "img/202505_01.b59ea430.jpg";